import { Helmet } from 'react-helmet-async';
import { StatusCard } from 'components';
import { useClientBlockedStatus } from 'hooks/webapi';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Flow from 'pages/Layouts/Flow/Flow';
import HeartIcon from 'assets/icons/heart.svg?react';
import styles from './Dana.module.scss';
import useLoginRedirection from 'hooks/useLoginRedirection';

/* SCREEN HIDDEN
export function isUserAffectedByDana(
  client: Client | undefined | null,
  latestLoan: LatestLoan | null | undefined | void,
) {
  const postalCode =
    client?.actualAddress?.postalCode || client?.declaredAddress?.postalCode;

  const todayPlus5 = dayjs().add(5, 'days').format('YYYY-MM-DD');

  const availableLoan =
    latestLoan &&
    (latestLoan.overDueDays ||
      !dayjs(todayPlus5).isBefore(latestLoan.nearestPaymentDate));

  if (postalCode && postalCode.startsWith('46') && availableLoan) {
    return true;
  }
  return false;
}*/

export const isUserAffectedByDana = () => false;

export default function Dana() {
  const { t } = useTranslation('dana');
  const { fetchClientBlockedStatus } = useClientBlockedStatus();
  const { redirectRouteDRAcceptedOrBlocked } = useLoginRedirection();

  const navigate = useNavigate();

  const handleContinue = async () => {
    const clientBlocked = await fetchClientBlockedStatus();
    navigate(redirectRouteDRAcceptedOrBlocked(clientBlocked));
  };

  return (
    <Flow
      className={styles.container}
      mobileHeading={t('html_title')}
      withLogout
      withMenuDisabled
    >
      <Helmet>
        <title>{t('html_title')}</title>
      </Helmet>
      <StatusCard
        dataTest="dana-statusCard"
        button={t('button')}
        contentClassName={styles['content-status-card']}
        descriptionClassName={styles.description}
        icon={<HeartIcon className={styles.icon} />}
        heading={t('title')}
        description={t('description')}
        onClick={handleContinue}
        className={styles.card}
      />
    </Flow>
  );
}
